import { create } from "zustand";
import type { BrandProfile } from "@/api/types";

// Active brand profile during customisation. Held in Zustand because it's
// touched by many sibling components (controls + preview + summary side)
// and would otherwise cause a lot of prop drilling.
//
// In Phase 2 this becomes a TanStack Query cache that syncs back to
// /api/brand-profiles, and the local edits become optimistic updates.

const DEMO_BRAND: BrandProfile = {
  id: "demo",
  name: "Demo Practice",
  accent: "#005EB8",
  secondary: "#003D78",
  tagline: "Your trusted regional health partner",
  rhText: "Self-test kit · For patients of Demo Practice",
  orgName: "Demo Practice",
  activationUrl: "demo-practice.example.com/activate",
  quantity: 50,
  kitName: "Self-testing kit",
  labAddress: "Demo Laboratories, 1 Example Street, London, EC1A 1AA",
  logo: null,
  logoSrc: null,
  logoText: "Demo",
  updated: new Date().toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  }),
};

type State = {
  brand: BrandProfile;
  version: number;
  setBrand: (patch: Partial<BrandProfile>) => void;
  setAccentPalette: (primary: string, secondary: string) => void;
  reset: () => void;
};

export const useBrandStore = create<State>((set) => ({
  brand: DEMO_BRAND,
  version: 1,
  setBrand: (patch) =>
    set((s) => ({ brand: { ...s.brand, ...patch }, version: s.version + 1 })),
  setAccentPalette: (primary, secondary) =>
    set((s) => ({
      brand: { ...s.brand, accent: primary, secondary },
      version: s.version + 1,
    })),
  reset: () => set({ brand: DEMO_BRAND, version: 1 }),
}));
